/*
 * @Author: caiqin.xie
 * @since: 2023-10-30 18:30:19
 * @lastTime: 2023-11-08 09:52:35
 * @LastEditors: caiqin.xie
 * @message: 字符串换行
 */
import React from "react";

export const splitLine = (str?: string) => {
  let reg = /<br\/>/g;
  return (
    (
      <div
        style={{
          whiteSpace: 'pre-line'
        }}
      >
        {str?.replace(reg, '\n') as any}
      </div>
    ) || ''
  );
};

export const transDocToHtml = (input: string) => {
  try {
    // abx#aaa@https://xxx#lll
    if (input.indexOf('#') !== -1) {
      const links: JSX.Element[] = [];
      let arr = input
        .replace(/#(.*?)@(.*?)#/g, (match, txt, link) => {
          links.push(
            <a href={link} target="__blank" key={txt}>
              {txt}
            </a>
          );
          return '#';
        })
        .split('#');
        const  res=[];
        while(arr.length>0){
          res.push(arr.shift(),links.shift());
        }
      return (
        <span>
          {res}
        </span>
      );
    } else {
      return <>{input}</>;
    }
  } catch (e) {
    return <>{input}</>;
  }
};
// 123{{xxx}}ccc{{xxx}}bbb替换成123<span>xxx</span>ccc<span>xxx</span>bbb
// 123[xxx]ccc[xxx]bbb替换成123<span>xxx</span>ccc<span>xxx</span>bbb
export const getSpan = (string: string) => {
  try {
    let pre = '{{';
    let after = '}}';
    if (string.indexOf('[') > -1) {
      pre = '[';
      after = ']';
    }
    const parts = string.split(pre);
    if (parts.length === 1) {
      return <div>{transDocToHtml(string)}</div>;
    }
    const result = [];
    result.push(parts[0]);
    for (let i = 1; i < parts.length; i++) {
      // 123、 xxx}}ccc,、xxx}}bbb
      const [inTxt, afterTxt] = parts[i].split(after); // xxx、ccc
      result.push(<span key={inTxt}>{transDocToHtml(inTxt)}</span>);
      afterTxt && result.push(transDocToHtml(afterTxt));
    }
    return <div>{result}</div>;
  } catch (e) {
    return <div>{transDocToHtml(string)}</div>;
  }
};
